import _extends from "@babel/runtime/helpers/extends";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Tabs/src/withTabContext.js",
  _this = this;
import TabContext from './TabContext';
import React from 'react';
import getComponentName from '../../../helpers/getComponentName';
/**
 * Inject TabContext props into the component
 * @param Component Target React component
 * @return {React.Component} Wrapped react component with `tabContext` prop.
 */

var withTabContext = function withTabContext(Component) {
  var WithTabContext = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TabContext.Consumer, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12,
        columnNumber: 5
      }
    }, function (tabContext) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        tabContext: tabContext,
        ref: ref,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 14,
          columnNumber: 16
        }
      }));
    });
  });
  WithTabContext.displayName = "WithTabContext".concat(getComponentName(Component));
  return WithTabContext;
};
export default withTabContext;